import React, { useEffect, useState, useContext } from 'react'
import PageHeader from '../../components/pageHeader/PageHeader';
import PageWrapper from '../../components/pageComponents/PageWrapper';
import ModalEnabled from '../../components/modalComponents/ModalEnabled';
import SearchContainer from '../../components/pageComponents/SearchContainer';
import useDidMountEffect from '../../hooks/useDidMountEffect/useDidMountEffect';
import { useGetRequest } from '../../hooks/useGetRequest/useGetRequest';
import { useManagePostRequest } from '../../hooks/useManagePostRequest/useManagePostRequest';
import { useGenerarDescargarEliminarArchivo } from '../../hooks/useGenerarDescargarEliminarArchivo/useGenerarDescargarEliminarArchivo';
import { AuthContext } from "../../hooks/context/authContext";
import { ROLES, FILE_FORMATS } from "../../constants/hardCodedConstants";
import ObservarRegistroModal from "./modales/ObservarRegistroModal";
import SpinnerLoading from '../../components/pageComponents/SpinnerLoading';
import SubirArchivoUpdateCts from './modales/SubirArchivoUpdateCts';

import {initialAllOptionPromises, jsonNoEstaVacio, updateFiltersWithExtraData, usuarioLogueadoTieneAlgunoDeLosSiguientesRoles} from "../../helper/utils";
import {getAllEstadosAPI, getAllCargosAPI, 
        getAllSedesAPI, getAllTipoDocumentoPagoAPI, getAllAniosDocumentoPagoAPI,getAllPeriodosDocumentoPagoAPI,
        getListaDocumentosPagoAPI,exportarDocumentosPagoAPI,
        bloquearEmpleadoDocumentoPagoAPI,desBloquearEmpleadoDocumentoPagoAPI,
        descargarReporteDocumentosPagoExcelAPI,
        cargarNumerosOperacionCtsAPI
    } from '../../consumers/backendApisUrls';

import styled from "styled-components";   
import TableDocumentoPago from "./TableDocumentoPago"; 
import DescargarDocumentoPago from './modales/DescargarDocumentoPago';
import HabilitarHistorialModal from './modales/HabilitarHistorialModal';
const INIT_KEYS = {
    IdsTipoDocumentosPago : "IdsTipoDocumentosPago",
    IdsEstados: "IdsEstados",
    IdsCargos: "IdsCargos",
    IdsSedes: "IdsSedes",    
    IdsAnios : "IdsAnios",
    IdsPeriodos : "IdsPeriodos",
    IdsEstadosEmpleado: "IdsEstadosEmpleado"
}

const GestionDocumentoPago = () => {
    const { state } = useContext(AuthContext);
    const [formValues, setFormValues] = useState({Items: [], ExtraData: {}, filters: [], selectedFilters: {}});
    const [allFilters, setAllFilters] = useState([]);
    const [idsDocumentosConCheck, setIdsDocumentosConCheck] = useState([]);
    const [searchCriteria, setSearchCriteria] = useState("");
    const [paginator, setPaginator] = useState({CurrentPage: 1});
    const [isLoading, setIsLoading] = useState(true);
    const [managePostRequest] = useManagePostRequest();
    const [modalEnabled, setModalEnabled] = useState({isEnable: false, component: React.Fragment});    
    const [executeGet] = useGetRequest();
    const [downloadAndDelete] = useGenerarDescargarEliminarArchivo();
    const [usuarioLogueadoTieneRolCompensaciones, setUsuarioLogueadoTieneRolCompensaciones] = useState(false);
    const [hideObservarRegistroModal, setHideObservarRegistroModal] = useState(true);
    const [hideDescargarDocumentoPagoModal, setHideDescargarDocumentoPagoModal] = useState(true);
    const [idEmpleadoDocumentoPago, setIdEmpleadoDocumentoPago] = useState(0);
    const [downloaAndDeletedReport] = useGenerarDescargarEliminarArchivo();
    const [hideHabilitarHistorialModal, setHideHabilitarHistorialModal] = useState(true);
    const [hasAdminRol, setHasAdminRol] = useState(false);
    const [hideSubirArchivoUpdateCtsModal, setHideSubirArchivoUpdateCtsModal] = useState(true);

    const initialPromises = () => {
        const response = executeGet(getAllEstadosAPI());
        return [
            executeGet(getAllTipoDocumentoPagoAPI()),            
            response,
            executeGet(getAllCargosAPI()),
            executeGet(getAllSedesAPI()),
            executeGet(getAllAniosDocumentoPagoAPI()),
            executeGet(getAllPeriodosDocumentoPagoAPI()),
            response
        ];
    }

    const init = async () => {
        setIsLoading(true);        
        const hasAdminRol = usuarioLogueadoTieneAlgunoDeLosSiguientesRoles(state.roleIds, [ROLES.SuperAdmin.id, ROLES.Compensaciones.id]);
        if (hasAdminRol) setHasAdminRol(hasAdminRol);        
        try {                        
            await initialAllOptionPromises(initialPromises, Object.values(INIT_KEYS), setAllFilters);
            await manageSearch();
            if (formValues.filters.length === 0) {
                jsonNoEstaVacio(formValues.ExtraData) &&
                updateFiltersWithExtraData(allFilters, formValues.ExtraData, handleUpdatedFilters);
            }
            setIsLoading(false);
        } catch (error) {
            console.error(error);
        } finally {
            setIsLoading(false);
        }
    }   

    const manageSearch = async () => {
        setIsLoading(true);
        const api = getListaDocumentosPagoAPI();
        const payload = getPayload();
        await managePostRequest(api, payload, successManageSearchCallback);
        setIdsDocumentosConCheck([]);
        setIsLoading(false);
    }

    const successManageSearchCallback = ({data}) => {
        const {Items, ExtraData, TotalItems, FirsItemPage, LastItemPage, TotalPages, CurrentPage} = data;
        setFormValues(lastData => ({...lastData, Items, ExtraData}));
        setPaginator({TotalItems, FirsItemPage, LastItemPage, TotalPages, CurrentPage});
        setIsLoading(false);
    }

    const getPayload = () => {
        return {
            Criteria: searchCriteria,
            Page: paginator.CurrentPage,
            ...formValues.selectedFilters
        }
    }

    const handleUpdatedFilters = (res) => {
        setFormValues(lastData => ({...lastData, filters: res}))
    }

    const handleCleanSearch = () => {
        setFormValues({...formValues, selectedFilters: null});
    }

    const handleExportarFile = async () => {
        const payload = getPayload();
        await downloadAndDelete(exportarDocumentosPagoAPI(), payload);
    }

    const manageSearchProxy = (response) => {
        manageSearch();
    }

    const bloquearEmpleadoDocumento = async function (IdEmpleadoDocumento) {
        let payload = {
            "IdEmpleadoDocumentoPago": IdEmpleadoDocumento
        };
        await managePostRequest(bloquearEmpleadoDocumentoPagoAPI(), payload, manageSearchProxy)
    }

    const desBloquearEmpleadoDocumento = async function (IdEmpleadoDocumento) {
        let payload = {
            "IdEmpleadoDocumentoPago": IdEmpleadoDocumento
        };
        await managePostRequest(desBloquearEmpleadoDocumentoPagoAPI(), payload, manageSearchProxy)
    }

    
    const toggleObservarRegistroModal = (IdEmpleadoDocumentoPago) => {
        setHideObservarRegistroModal(!hideObservarRegistroModal);
        IdEmpleadoDocumentoPago && setIdEmpleadoDocumentoPago(IdEmpleadoDocumentoPago) //if truthy  
    }

    const toggleDescargarDocumentoPagoModal = (IdEmpleadoDocumentoPago) => {
        setHideDescargarDocumentoPagoModal(!hideDescargarDocumentoPagoModal);
        IdEmpleadoDocumentoPago && setIdEmpleadoDocumentoPago(IdEmpleadoDocumentoPago)  
    }

    const toggleHabilitarHistorialModal = () => {
        setHideHabilitarHistorialModal(!hideHabilitarHistorialModal);
    }

    const handleDescargarDocumentosPago = async () => {
        const payload = getPayload();
        const api = descargarReporteDocumentosPagoExcelAPI();
        await downloaAndDeletedReport(api, payload);
    }

    const toggleSubirArchivoUpdateCtsModal = () => {
        setHideSubirArchivoUpdateCtsModal(!hideSubirArchivoUpdateCtsModal);        
    }

    const mostrarHabilitarHistorialModal = async () => {
        let currentState = hideHabilitarHistorialModal;
        setHideHabilitarHistorialModal(!currentState);
    }
    const mostrarSubirArchivoUpdateCtsModal = async () => {
        let currentState = hideSubirArchivoUpdateCtsModal;
        setHideSubirArchivoUpdateCtsModal(!currentState);
    }
    useDidMountEffect(() => {
        manageSearch();
    }, [paginator.CurrentPage, formValues.selectedFilters])

    useDidMountEffect(() => {
        jsonNoEstaVacio(formValues.ExtraData) && updateFiltersWithExtraData(allFilters, formValues.ExtraData, handleUpdatedFilters);
    }, [formValues.ExtraData])
    
    useEffect(() => {
        init();
    }, [])

    if (isLoading) return <SpinnerLoading />
    return (
        <>  
        {hideObservarRegistroModal === false &&
            <div className="modal-contactanos modal-response-ficha-background">
                <ObservarRegistroModal toggleModal={toggleObservarRegistroModal} idEmpleadoDocumentoPago={idEmpleadoDocumentoPago} refreshTable={manageSearch} />                
            </div>
        }
        {hideDescargarDocumentoPagoModal === false &&
            <div className="modal-contactanos modal-response-ficha-background">
                <DescargarDocumentoPago toggleModal={toggleDescargarDocumentoPagoModal} 
                    idEmpleadoDocumentoPago={idEmpleadoDocumentoPago} 
                    refreshTable={manageSearch} 
                    fromAdminPage={true}/>
            </div>
        }
        {hideHabilitarHistorialModal === false &&        
            <div className="modal-contactanos modal-response-ficha-background">
                <HabilitarHistorialModal 
                    toggleModal={toggleHabilitarHistorialModal} 
                    refreshTable={manageSearch} 
                    validExtensions={FILE_FORMATS.EXCEL_FORMATS}
                />                
            </div>
        }
        {hideSubirArchivoUpdateCtsModal === false &&   
            <div className="modal-contactanos modal-response-ficha-background">
                <SubirArchivoUpdateCts 
                    api= {cargarNumerosOperacionCtsAPI()}
                    toggleModal={toggleSubirArchivoUpdateCtsModal}                     
                    refreshPage={manageSearch} 
                    validExtensions={FILE_FORMATS.EXCEL_FORMATS}
                />
            </div>
        }
        <PageWrapper isLoading={isLoading}>
            <ModalEnabled
                modalEnabled={modalEnabled}
                setModalEnabled={setModalEnabled}
                refreshPage={manageSearch}
            />
            <PageHeader title={"Gestión de Documentos de Pago"}/>

            <SearchContainer
                searchCriteria={searchCriteria}
                setSearchCriteria={setSearchCriteria}
                setPaginator={setPaginator}
                manageSearch={manageSearch}
                addCleanSearch={handleCleanSearch}>
                
                <ButtonsWrapper>
                    <div className="d-flex">  
                        {formValues.ExtraData.PuedeActivarHistorial === true && hasAdminRol &&                 
                        <button type='button' 
                            className='generic-button-buscador' 
                            onClick={mostrarHabilitarHistorialModal}>Habilitar Historial</button>                                                    
                        }
                        {formValues.ExtraData.PuedeActivarHistorial === true && hasAdminRol &&                 
                        <button type='button' 
                            className='generic-button-buscador' 
                            onClick={mostrarSubirArchivoUpdateCtsModal}>Actualizar Nro. Operación CTS</button>                                                    
                        }
                        {formValues.ExtraData.PuedeDescargarExcel === true &&                  
                        <button type='button' 
                            className='generic-button-buscador' 
                            onClick={handleDescargarDocumentosPago}>Exportar</button>                                                    
                        }
                        {formValues.ExtraData.PuedeDescargarZip === true && 
                        <button type='button' 
                            className='generic-button-buscador' 
                            onClick={handleExportarFile}>Descargar Zip</button>
                        }

                        {/* <NavDropdown id={"navDropdown-admiGestionDeDocumentosPago"}
                            className="generic-button-dropdown font-gothan-light"
                            title={
                                <span className="generic-button-dropdown-title">Acciones</span>
                            }
                            >
                            <NavDropdown.Item onClick="">Aprobar Masivo</NavDropdown.Item>                            
                        </NavDropdown> */}
                    </div>
                </ButtonsWrapper>
            </SearchContainer>

            <TableDocumentoPago
                formValues={formValues}
                setFormValues={setFormValues}
                extraData={formValues.ExtraData}
                setModalEnabled={setModalEnabled}
                paginator={paginator}
                setPaginator={setPaginator}
                keys={INIT_KEYS}
                idsDocumentosConCheck={idsDocumentosConCheck}
                setIdsDocumentosConCheck={setIdsDocumentosConCheck}
                manageSearch={manageSearch}
                fromAdminPage={true}
                bloquearEmpleadoDocumento={bloquearEmpleadoDocumento}
                desBloquearEmpleadoDocumento={desBloquearEmpleadoDocumento}
                toggleObservarRegistroModal={toggleObservarRegistroModal}
                toggleDescargarDocumentoPagoModal={toggleDescargarDocumentoPagoModal}                
            />            

        </PageWrapper>
    </>
    )
}

export default GestionDocumentoPago

const ButtonsWrapper = styled.div`
    display: block;
    @media (max-width: 796px) {
        display: none;
    }
`;

// const DCenter = ({ children }) => (
//   <div className='d-flex justify-content-center'>
//     {children}
//   </div>
// )